import * as React from "react"
import { MobilePrevSpeakerStreamsProps } from "./mobile-prev-speaker-steams.interface"
import { Root } from "./mobile-prev-speaker-steams.styled"
import { MobilePrevSpeakerStream } from "./mobile-prev-speaker-stream"
const UserPermission = window.MeetOnline.UserPermission

const _MobilePrevSpeakerStreams: React.FC<MobilePrevSpeakerStreamsProps> = ({
  otherUserIds,
  smallScreenStyling,
  isTablet,
  isMainScreen,
  localUserProperties,
  screenWidth,
  isOnlyScreensView
}): JSX.Element => {
  const [isSmallScreenButtons, setIsSmallScreenButtons] =
    React.useState<boolean>(false)

  // show icons on Permission change for audience by moderator - START
  const wasAllowedBefore = (p: number): boolean => {
    return (localUserProperties.oldPermissions & p) !== 0
  }
  const isAllowedNow = (p: number): boolean => {
    return (localUserProperties.permissions & p) !== 0
  }

  React.useEffect(() => {
    let showPermissionToast: boolean = false
    if (localUserProperties.oldPermissions) {
      if (
        localUserProperties.permissions !== localUserProperties.oldPermissions
      ) {
        if (
          isAllowedNow(UserPermission.canUseMic) !==
          wasAllowedBefore(UserPermission.canUseMic)
        ) {
          showPermissionToast = true
        } else if (
          isAllowedNow(UserPermission.canUseCam) !==
          wasAllowedBefore(UserPermission.canUseCam)
        ) {
          showPermissionToast = true
        }
      }
    }

    if (showPermissionToast) {
      if (isSmallScreenButtons) {
        setIsSmallScreenButtons(false)
      }

      setIsSmallScreenButtons(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    localUserProperties.permissions,
    localUserProperties.oldPermissions,
    UserPermission.canUseMic,
    UserPermission.canUseCam,
    UserPermission.canUseScreenshare
  ])

  React.useEffect(() => {
    let showLocalButtons = setTimeout(() => {
      if (isSmallScreenButtons) {
        setIsSmallScreenButtons(false)
      }
    }, 5000)
    return () => clearTimeout(showLocalButtons)
  }, [isSmallScreenButtons])

  return (
    <Root
      spacing="8"
      id="remote-players"
      gridColumnGap={isTablet && "10px"}
      width={isOnlyScreensView && `${screenWidth}px !important`}
    >
      {otherUserIds.map((uid, index) => (
        <MobilePrevSpeakerStream
          key={`mobile-prev-speaker-stream-${index}`}
          uid={uid}
          isTablet={isTablet}
          localUserProperties={localUserProperties}
          smallScreenStyling={smallScreenStyling}
        />
      ))}
    </Root>
  )
}

export const MobilePrevSpeakerStreams = React.memo(_MobilePrevSpeakerStreams)
